import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { useAuth } from '../../context/AuthContext';

// Module placement for the community panel.
// community_admin/community_staff see their tenant's tools.
// Module-specific links (consultation, communityNews) are gated via allowedModules.
const CommunityShell = () => {
  const { activeTenant, isModuleEnabled, access } = useAuth();
  const communityRole = activeTenant ? access?.communityRoles?.[activeTenant._id] : null;
  const isCommunityAdmin = communityRole === 'community_admin';

  const baseNav = [
    { to: '/dashboard',  label: 'Dashboard' },
    { to: '/coms',       label: '💬 Coms Hub' },
    { to: '/membership', label: 'Membership' },
  ];

  const moduleNav = [
    isModuleEnabled('consultation')  && { to: '/consultation',   label: 'Consultation' },
    isModuleEnabled('communityNews') && { to: '/community-news', label: 'Community News' },
    isModuleEnabled('communityData') && { to: '/community-data', label: 'Community Data' },
    isModuleEnabled('harvesting')    && { to: '/harvesting',     label: '🌿 Harvesting' },
    isModuleEnabled('landValues')    && { to: '/land-values',    label: '🗺️ Land Values' },
    isModuleEnabled('landUnits')     && { to: '/land-units',     label: '🗻 Land Units' },
  ].filter(Boolean);

  const adminNav = isCommunityAdmin
    ? [{ to: '/community-admin', label: 'Manage Community' }]
    : [];

  const nav = [...baseNav, ...moduleNav, ...adminNav];

  return (
    <div className="shell shell--community">
      <Navbar />
      {activeTenant?.branding?.bannerText && (
        <div className="shell-community-banner">
          {activeTenant.branding.bannerText}
        </div>
      )}
      <div className="shell-body">
        <nav className="shell-sidenav" aria-label="Community navigation">
          <span className="shell-sidenav__heading">
            {activeTenant?.branding?.displayName || activeTenant?.name || 'Community'}
          </span>
          <ul>
            {nav.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="shell-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CommunityShell;
